module.exports = __webpack_public_path__ + "img/clipboard-prescription.a8763382.svg";